import HtmlToReact from 'html-to-react';

export const replacePlaceHolders = (html, dictionary) => Object.keys(dictionary).reduce((finalHtml, key) => {
  const re = new RegExp(key, 'g');
  return finalHtml.replace(re, dictionary[key]);
}, html || '');

export const renderHtml = (html, dictionary) => {
  const processedHtml = replacePlaceHolders(html, dictionary);
  const HtmlToReactParser = HtmlToReact.Parser;
  const htmlToReactParser = new HtmlToReactParser();
  return htmlToReactParser.parse(processedHtml);
};
